import { Row, Col } from 'antd';
import { useLabelPrintingContext } from '../..';

export default function LabelPrintingToolbarCustomPanel() {
  const { customOptions } = useLabelPrintingContext();

  if (!customOptions?.length) return null;

  return (
    <>
      <Row gutter={[16, 0]}>
        {customOptions?.map((field) => (
          <Col span={24} {...field.colProps}>
            {field.component}
          </Col>
        ))}
      </Row>
    </>
  );
}
